/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, View, type StyleProp, type ViewStyle } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import type { ComponentProps } from 'react';
import { colors, ticketColors } from '../theme/public-api';
import { operationalFilterStyles as styles } from './operationalFilters.styles';

type IconName = ComponentProps<typeof Ionicons>['name'];

type Props = {
  label: string;
  selected: boolean;
  disabled?: boolean;
  onPress: () => void;
  iconName?: IconName;
  accessibilityLabel: string;
  style?: StyleProp<ViewStyle>;
  hint?: string;
  /** Brand-solid selected state on ticket surfaces. */
  ticketTone?: boolean;
};

/** Chip con ícono opcional (p. ej. «Solo con stock» en POS). */
export function OperationalFilterToggleChip({
  label,
  selected,
  disabled = false,
  onPress,
  iconName,
  accessibilityLabel,
  style,
  hint,
  ticketTone = false,
}: Props) {
  return (
    <View style={[{ gap: 4, alignSelf: 'flex-start' }, style]}>
      <TouchableOpacity
        style={[
          styles.chip,
          styles.toggleChipInner,
          ticketTone && styles.chipTicket,
          selected && (ticketTone ? styles.chipActiveTicket : styles.chipActive),
          disabled && styles.toggleChipDisabled,
        ]}
        onPress={() => {
          if (!disabled) onPress();
        }}
        disabled={disabled}
        accessibilityRole="switch"
        accessibilityState={{ checked: selected, disabled }}
        accessibilityLabel={accessibilityLabel}
      >
        {iconName ? (
          <Ionicons
            name={iconName}
            size={14}
            color={
              selected
                ? ticketTone
                  ? ticketColors.goldInk
                  : '#FFFFFF'
                : colors.textSecondary
            }
          />
        ) : null}
        <Text
          style={[
            styles.chipText,
            ticketTone && styles.chipTextTicket,
            selected && (ticketTone ? styles.chipTextActiveTicket : styles.chipTextActive),
          ]}
          numberOfLines={1}
        >
          {label}
        </Text>
      </TouchableOpacity>
      {hint ? <Text style={styles.toggleChipHint}>{hint}</Text> : null}
    </View>
  );
}
